import type { SlateEditorType } from '@builder4/shared/types/text';
import { Editor } from 'slate';

export const handleSlateKeyDown = (editor: SlateEditorType, event: React.KeyboardEvent) => {
  // Handle Ctrl+key (Windows/Linux) and Cmd+key (macOS) combinations
  if (!event.ctrlKey && !event.metaKey) {
    return;
  }

  switch (event.key) {
    case 'b': {
      event.preventDefault();
      const marks = Editor.marks(editor);
      const isActive = marks ? marks.bold === true : false;
      if (isActive) {
        Editor.removeMark(editor, 'bold');
      } else {
        Editor.addMark(editor, 'bold', true);
      }
      break;
    }
    case 'i': {
      event.preventDefault();
      const marks = Editor.marks(editor);
      const isActive = marks ? marks.italic === true : false;
      if (isActive) {
        Editor.removeMark(editor, 'italic');
      } else {
        Editor.addMark(editor, 'italic', true);
      }
      break;
    }
    case 'u': {
      event.preventDefault();
      const marks = Editor.marks(editor);
      const isActive = marks ? marks.underline === true : false;
      if (isActive) {
        Editor.removeMark(editor, 'underline');
      } else {
        Editor.addMark(editor, 'underline', true);
      }
      break;
    }
  }
};
